import { render, staticRenderFns } from "./AddReviewer.vue?vue&type=template&id=3e71d93a&scoped=true&"
import script from "./AddReviewer.vue?vue&type=script&lang=js&"
export * from "./AddReviewer.vue?vue&type=script&lang=js&"
import style0 from "./AddReviewer.vue?vue&type=style&index=0&id=3e71d93a&prod&lang=css&"
import style1 from "./AddReviewer.vue?vue&type=style&index=1&id=3e71d93a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e71d93a",
  null
  
)

export default component.exports